// extracted by mini-css-extract-plugin
module.exports = {"button":"Link_button__3g89K","button--red":"Link_button--red__27CEY","link":"Link_link__2DVDX"};